import dayjs from 'dayjs'
import type { TFunction } from 'i18next'

export function formatRequestedAgo(t: TFunction, iso: string): string {
  const d = dayjs(iso)
  if (!d.isValid()) return ''
  const now = dayjs()
  const seconds = Math.max(0, now.diff(d, 'second'))
  if (seconds < 60) {
    return t('carrierRequests.ago.seconds', { count: seconds })
  }
  const minutes = now.diff(d, 'minute')
  if (minutes < 60) {
    return t('carrierRequests.ago.minutes', { count: minutes })
  }
  const hours = now.diff(d, 'hour')
  if (hours < 24) {
    return t('carrierRequests.ago.hours', { count: hours })
  }
  const days = now.diff(d, 'day')
  return t('carrierRequests.ago.days', { count: days })
}
